import { logoutApi } from "@/api/services/admin/auth";
import { ADMIN_EMAIL_KEY, ADMIN_REFRESH_TOKEN_KEY, CONTRACT_TOKEN_KEY } from "@/utils/constants";
import { removeToken } from "@/utils/token";
import Cookies from "js-cookie";

/**
 * Revokes the session server-side (best effort) then clears it locally: removes
 * tokens (and their Axios auth headers) plus the identity cookies. Call this
 * before starting a fresh session or when the current session becomes invalid.
 */
export const logout = async (): Promise<string | undefined> => {
  const refreshToken = Cookies.get(ADMIN_REFRESH_TOKEN_KEY);
  if (refreshToken) {
    // A failing revoke must not strand the user in a half-authenticated UI.
    await logoutApi({ refreshToken }).catch(() => {
      // do nothing
    });
  }
  const email = Cookies.get(ADMIN_EMAIL_KEY);
  removeToken();
  Cookies.remove(ADMIN_EMAIL_KEY);
  Cookies.remove(CONTRACT_TOKEN_KEY);
  return email;
};
